
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"viewBox":"0 0 360 322"}},[_c('path',{attrs:{"fill":"#1D4563","d":"M47.928 263.22L2.89 120.826C-3.852 99.51 7.84 76.745 29.094 69.808L242.973 0 360 91.014l-27.821 157.155L214.366 322 47.928 263.22z"}})])
      }
    
      }
    